import styled from '~/utils/styled';
// ---- external imports ----

import Asset from '~/containers/GameAsset/BaseAssets';
import { PrimaryButton, createPrimaryButtonText } from '~/authentication/AuthAssets';
// ---- internal imports ----

// region [Projection Constants]
export const BODY_TEXT_PROJECTION = { width: 632 };
export const ACTION_PROJECTION = { width: 632 };
export const RETRY_BUTTON_TEXT_PROJECTION = { width: 158 };
// endregion

// region [Components]

export const BodyText = styled(Asset.Text.withProps({
	fontSize: 32,
	projection: BODY_TEXT_PROJECTION,
}))`
	font-family: "NotoSans ExtraBold";
	color: #fff5b0;
	text-align: center;
`;

export const RetryButton = PrimaryButton;

export const RetryButtonText = createPrimaryButtonText(RETRY_BUTTON_TEXT_PROJECTION);

// A button rather than a router link on every route this screen appears on: the
// player may be leaving mid-retry, and only a button can be disabled while the
// provider's chain is still running.
export const BackToLoginButton = styled(Asset.Button.withProps({
	fontSize: 24,
	projection: ACTION_PROJECTION,
}))`
	background-color: transparent;
	border: none;
	padding: 0;
	font-family: "NotoSans";
	color: #fff5b0;
	text-decoration: underline;
	text-align: center;
`;

// endregion
